import { View } from '../server/view';

export class ViewChangeEvent {
    currentView: View;
    precedentView: View;
}
